<script setup lang="ts">
  import { watch } from 'vue'
  import { useRoute } from 'vue-router'
  import SidebarItems from './sidebar-items.vue'

  const route = useRoute()
  const showSidebarMobile = defineModel<boolean>({ required: true })

  watch(() => route.fullPath, () => {
    showSidebarMobile.value = false
  })

  const appVersion = __APP_VERSION__
</script>

<template>
  <transition name="fade">
    <app-button
      v-if="showSidebarMobile"
      class="fixed inset-0 z-10 bg-black opacity-50 lg:hidden"
      @click="showSidebarMobile = false" />
  </transition>

  <div
    class="fixed inset-y-0 z-10 w-64 flex flex-col border-r bg-app px-4 transition-all duration-200 lg:left-0 lg:right-unset lg:w-40"
    :class="{
      'max-lg:right-0': showSidebarMobile,
      '-right-64': !showSidebarMobile
    }">
    <div class="h-12 flex items-center border-b space-x-3">
      <img
        src="/scm-logo.svg"
        alt="Logo SCM"
        class="block size-5 rounded-full">
      <div class="flex-1 font-bold">
        SCM
      </div>
      <div>
        <app-button
          class="h-8 flex-center text-xl lg:hidden"
          @click="showSidebarMobile = false">
          <fa-icon icon="i-far-xmark" />
        </app-button>
      </div>
    </div>
    <sidebar-items class="flex-1" />
    <div class="py-2 text-center text-sm">
      v{{ appVersion }}
    </div>
  </div>
</template>
